import React, {useContext, useEffect, useState, useCallback} from "react";
import Grid from '@mui/material/Grid';
import { makeStyles } from '@mui/styles';
import axios from "../api/axios";
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Container from '@mui/material/Container';
import UserContext from '../contexts/UserContext';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import ListSeminars from "./ListSeminars";
import ListTrainings from "./ListTrainings";
import parseISO from 'date-fns/parseISO'
import EditSeminarDialog from './EditSeminarDialog';
import EditTrainingDialog from "./EditTrainingDialog";

const useStyles = makeStyles((theme) => ({
	wrapper: {
		maxWidth: 1140,
		marginLeft: "auto",
		marginRight: "auto",
        marginTop: '150px'
	},
    marginTop: {
        marginTop: '10px;' 
    },
    marginBottom: {
        marginBottom: "15px",
        paddingBottom: "15px"
    },
    paddingTopBottom: {
        paddingTop: '20px;',
        paddingBottom: '20px;'
    },
    padding: {
        marginRight: "10px"
    },
    search: {
		width: 175,
		backgroundColor: "white",
		borderRadius: 8,
		"& .MuiInputBase-root": {
			marginBottom: 0,
		},
		"&:hover": {
			backgroundColor: "grey",
		},
	}
})); 

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Container>
                    <Box>
                        {children}
                    </Box>
                </Container>
            )}
        </div>
    );
}
  
TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};
  
function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}
  

const Lists = () => {

    const classes = useStyles();
    const userContext = useContext(UserContext);
    const getToken = userContext.checklocalStorage();
    const isAuth = userContext.isAuth;

    const [seminars, setSeminars] = useState([]);
    const [trainings, setTrainings] = useState([]);
    const [value, setValue] = useState(0);

    const [openSeminar, setOpenSeminar] = useState(false);
    const [editSeminar, setEditSeminar] = useState({ title:"", host:"", city:"",  number: "", link:"", audience: "", cancelled:"", date: null, end_date: null, date_time:"", academic_year: "", description:""});

    const [openTraining, setOpenTraining] = useState(false);
    const [editTraining, setEditTraining] = useState({title:"", type: "", subject: "", network: "", institution: "", duration:0, ecpoints:0, start:"", contact: "", link:"", cost: "", note: ""});
    
    const[host, setHost] =  useState([]);
    const[city, setCity] =  useState([]);
    const[academicYear, setAcademicYear] =  useState([]);

    const[institution, setInstitution] =  useState([]);
    const[subject, setSubject] =  useState([]);
    const[start, setStart] =  useState([]);
      
    const handleChange = (event, newValue) => {
      setValue(newValue);
    };

    const fetchSeminars = useCallback(() => {
        axios.get('/seminars/view-seminars')
            .then(function (res) {
                setSeminars(res.data.response)
                addHosts(res.data.response)
                addCities(res.data.response)
                addAcademicYears(res.data.response)
            })
            .catch((err) => { console.log(err); });
    }, []);

    const fetchTrainings = useCallback(() => {
        axios.get('/trainings/view-trainings')
            .then(function (res) {
                setTrainings(res.data.response)
                addInstitution(res.data.response)
                addSubject(res.data.response)
                addStart(res.data.response)
            })
            .catch((err) => { console.log(err); });
    }, []);

    useEffect(() => {
        fetchSeminars();
        fetchTrainings();
    }, [fetchSeminars, fetchTrainings]);

    /**
     * Convert a database date 2020-01-29T16:04:37 or a date object to human readable date 29.1.2020
     * @param {String|Date} date
     */
    const formatDate = (date = null) => {

        if(date){
                const dateobject = date
                ? date instanceof Date
                    ? date
                    : parseISO(date)
                : new Date();
            
            return (
                dateobject.getDate() +
                "." +
                (dateobject.getMonth() + 1) +
                "." +
                dateobject.getFullYear()
            );
        } else {
            return ''
        }
        
    };

    const addHosts = (data) => {
        var hosts = [];

        console.log(data)
        
        if(data.length > 0){
            data.forEach((seminar) => {
                if(seminar.host !== null && seminar.host.length > 0 && hosts.indexOf(seminar.host) === -1){
                    hosts.push(seminar.host)
                }
            });
        }
        setHost(hosts);
    }

    const addCities = (data) => {
        var cities = [];
        
        if(data.length > 0){
            data.forEach((seminar) => {
                if(seminar.city !== null && seminar.city.length > 0 && cities.indexOf(seminar.city) === -1){
                    cities.push(seminar.city)
                }
            });
        }
        setCity(cities);
    }

    const addAcademicYears = (data) => {
        var years = [];
        
        if(data.length > 0){
            data.forEach((seminar) => {
                if(seminar.academic_year !== null && seminar.academic_year.length > 0 && years.indexOf(seminar.academic_year) === -1){
                    years.push(seminar.academic_year)
                }
            });
        }
        setAcademicYear(years);
    }

    const addInstitution = (data) => {
        var institutions = [];
        
        if(data.length > 0){
            data.forEach((training) => {
                if(training.institution !== null && training.institution.length > 0 && institutions.indexOf(training.institution) === -1){
                    institutions.push(training.institution)
                }
            });
        }
        setInstitution(institutions);
    }

    const addSubject = (data) => {
        var subjects = [];
        
        if(data.length > 0){
            data.forEach((training) => {
                if(training.subject !== null && training.subject.length > 0 && subjects.indexOf(training.subject) === -1){
                    subjects.push(training.subject)
                }
            });
        }
        setSubject(subjects);
    }

    const addStart= (data) => {
        var starts = [];
        
        if(data.length > 0){
            data.forEach((training) => {
                if(training.start !== null && training.start.length > 0 && starts.indexOf(training.start) === -1){
                    starts.push(training.start)
                }
            });
        }
        setStart(starts);
    }

    const addSeminar = (seminar) => {

        let semDate = seminar.date;
        let semEndDate = seminar.end_date;

        if(semDate instanceof Date) {
            semDate = seminar.date.toISOString().split('T')[0]
        }

        if( semEndDate instanceof Date) {
            semEndDate = seminar.end_date.toISOString().split('T')[0]
        }

        const options = {
            url: `/seminars/create-seminar`,
            data: {
                title: seminar.title, 
                host: seminar.host, 
                city: seminar.city,  
                number: seminar.number, 
                link: seminar.link, 
                audience: seminar.audience, 
                cancelled: seminar.cancelled, 
                date: semDate,
                end_date: semEndDate,
                date_time: seminar.date_time,
                academic_year: seminar.academic_year,
                description: seminar.description
            },
            method: 'post',
            headers: getToken
        };
        
        return axios(options)
            .then((res) => {
                fetchSeminars();
            })
        .catch((error) => { console.log(error); });

    }

    const addTraining = (training) => {

        const options = {
            url: `/trainings/create-training`,
            data: {
                type: training.type,
                subject: training.subject,
                network: training.network, 
                institution: training.institution, 
                title: training.title, 
                duration: training.duration, 
                ecpoints: training.ecpoints, 
                start: training.start, 
                contact: training.contact, 
                link: training.link, 
                cost: training.cost, 
                note: training.note, 
            },
            method: 'post',
            headers: getToken
        };
        
        return axios(options)
            .then((res) => {
                fetchTrainings();
            })
        .catch((error) => { console.log(error); });

    }

    return(
        <>
            <Paper className={classes.wrapper}>
                <Box sx={{ width: '100%' }}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                        <Tab label="Bundesseminare" {...a11yProps(0)} />
                        <Tab label="Weiterbildungen" {...a11yProps(1)} />
                        </Tabs>
                    </Box>
                    <TabPanel value={value} index={0} className={classes.paddingTopBottom}>
                        { isAuth ? 
                            <Grid item xs={12} className={classes.marginBottom} >   
                                <Button variant="outlined" onClick={() => { setOpenSeminar(true)}} startIcon={<AddIcon /> }>
                                    Bundesseminar hinzufügen
                                </Button>
                            </Grid>
                        : ''}
                        < ListSeminars 
                            seminars={seminars}
                            isAuth={isAuth} 
                            fetchSeminars={fetchSeminars}
                            getToken={getToken}
                            host = {host}
                            city = {city}
                            academicYear={academicYear}
                            formatDate = {formatDate}
                        />
                    </TabPanel>
                    <TabPanel value={value} index={1} className={classes.paddingTopBottom}>
                        { isAuth ? 
                            <Grid item xs={12} className={classes.marginBottom} >   
                                <Button variant="outlined" onClick={() => { setOpenTraining(true)}} startIcon={<AddIcon />}>
                                    Weiterbildung hinzufügen
                                </Button>
                            </Grid>
                        : ''}
                        < ListTrainings 
                            trainings={trainings} 
                            isAuth={isAuth} 
                            fetchTrainings={fetchTrainings}
                            getToken={getToken}
                            institution = {institution}
                            subject = {subject}
                            start = {start}
                        />
                    </TabPanel>
                </Box>
            </Paper>

            {/* Add Seminar Dialog */}
            <EditSeminarDialog
                isDialogOpen={openSeminar}
                setIsDialogOpen={setOpenSeminar}
                editSeminar={editSeminar}
                setEditSeminar={setEditSeminar}
                saveCallback={addSeminar}
                autoCompletes={{hosts: host, cities: city}}
            /> 

            {/* Add Training Dialog */}
            <EditTrainingDialog
                isDialogOpen={openTraining}
                setIsDialogOpen={setOpenTraining}
                editTraining={editTraining}
                setEditTraining={setEditTraining}
                saveCallback={addTraining}
                autoCompletes={{ institutions: institution, subjects: subject}}
            /> 
        </>
    )
}

export default Lists;